import MarketingLayout from "@/components/MarketingLayout";
import SEOPageNew from "@/pages/newsite/SEOPageNew";

export default function AdScriptGeneratorPage() {
  return (
    <MarketingLayout>
      <SEOPageNew />
    </MarketingLayout>
  );
}
